import React, { useEffect } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import {
  getLangName,
  getLangWord,
  langState,
  langText,
} from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { setRecoil } from "recoil-nexus";
import { useRecoilValue } from "recoil";

const langList = [0, 1, 2, 3, 4, 5, 6, 7, 8];

const LanguageModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const lang = useRecoilValue<number>(langState);

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  const selectLang = (lang: number) => {
    try {
      LogController.click({
        path: "LanguageModal",
        params: "lang",
        params2: getLangName(lang) + " 언어 변경 클릭",
        index: lang,
      });
    } catch (err) {
      console.log(err);
    }
    setRecoil(langState, lang);
    onCloseModal();
  };

  useEffect(() => {}, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "languageModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <div className="header_title">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_language.svg`}
                width={24}
                height={24}
                alt="ic"
              />
              <h6>Language</h6>
            </div>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            {langList.map((item, index) => (
              <button
                key={index}
                className={`typeButton ${lang === item && "active"}`}
                onClick={() => selectLang(item)}
              >
                <img
                  className="langIcon"
                  src={`${
                    process.env.PUBLIC_URL
                  }/knockknock/svg/lang/ic_lang_${getLangWord(item)}.svg`}
                  alt="ic"
                />
                {langText.languageModal_lang[item]}
              </button>
            ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default LanguageModal;

const Style = styled.div`
  .modal {
    padding: 25px 24px;
  }

  .modal_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .header_title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      img {
        margin-right: 6px;
      }
    }
    h6 {
      font-size: 24px;
      line-height: 36px;
      font-weight: 200;
      color: #ffffff;
    }
    .closeIcon {
      margin-left: auto;
    }
  }
  .modal_content {
    padding: 32px 0 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .typeButton {
    width: 30%;
    margin: 5px;
    padding: 12px 0;
    background: #343434;
    border: 2px solid #e5e5e5;
    border-radius: 10px;
    font-size: 24px;
    line-height: 30px;
    color: #e5e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;

    img {
      height: 32px;
    }
  }
  .typeButton.active {
    background: #4dd2ae;
  }
`;
